const STORAGE_KEY = 'pedidoo::tenantSlug';

let currentSlug: string | null = null;

const isBrowser = typeof window !== 'undefined';

const readFromStorage = () => {
  if (!isBrowser) {
    return null;
  }

  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

const writeToStorage = (value: string | null) => {
  if (!isBrowser) {
    return;
  }

  try {
    if (value) {
      sessionStorage.setItem(STORAGE_KEY, value);
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // ignore storage errors (private mode etc.)
  }
};

export const tenantManager = {
  getSlug(): string | null {
    if (currentSlug) {
      return currentSlug;
    }

    currentSlug = readFromStorage();
    return currentSlug;
  },

  setSlug(slug: string | null) {
    currentSlug = slug;
    writeToStorage(slug);
  },

  clear() {
    this.setSlug(null);
  },
};

